import { render, staticRenderFns } from "./Descprition1.vue?vue&type=template&id=2ad60a66&"
import script from "./Descprition1.vue?vue&type=script&lang=js&"
export * from "./Descprition1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports